import { FC, useState } from 'react';
import { Grid } from '@mui/material';

import { APP_URLS } from 'src/constants';
import { useNavigate } from 'react-router-dom';
import { IRegisterForm, IRegisterVerificationForm } from 'src/types';

import { RegisterForm, RegisterVerificationForm } from './components';

const Register: FC = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [page, setPage] = useState<'register' | 'verification'>('register');

  const onCompleted = async (form: IRegisterForm) => {
    setUserName(form.name);
    setPage('verification');
  };

  const onVerified = async (form: IRegisterVerificationForm) => {
    navigate(APP_URLS.LOGIN);
  };

  return (
    <Grid container justifyContent="center" sx={{ p: 3 }}>
      <Grid item xs={6} className="cb-card">
        {page === 'register' && <RegisterForm onComplete={onCompleted} />}
        {page === 'verification' && <RegisterVerificationForm user={userName} onComplete={onVerified} />}
      </Grid>
    </Grid>
  );
};

export default Register;
